import React, { useEffect, useState, useCallback, useMemo } from 'react';
import { Row, Col, Card, CardBody, Container, Spinner } from 'reactstrap';

import * as weeklyPushNotificationsActions from '../../store/pushNotifications/weekly/actions';
import { useDispatch, useSelector } from 'react-redux';
import FormWeeklyPushNotification from '../../components/PushNotifications/Weekly/FormWeeklyPushNotification';
import Modal from '../../components/Common/Modal/Modal';
import ShowSingleElement from '../../components/Common/ShowSingleElement';
import Breadcrumbs from '../../components/Common/Breadcrumb';
import DataTableNext from '../../components/Common/DataTable/DataTableNext';
import createTableColumns from '../../components/PushNotifications/Weekly/tableColumns';
import {
  ExportButtonPlacement,
  ToggleColumnButton,
  CreateButton,
} from '../../components/Common/DataTable/tableActionButtons';
import { addOrRemove } from '../../helpers/sharedFunction';

const WeeklyPushNotifications = () => {
  const loading = useSelector((state) => state.WeeklyPushNotification.loading);
  const weeklyPushNotifications = useSelector(
    (state) => state.WeeklyPushNotification.weeklyPushNotifications,
  );

  const [selectedWeeklyPushNotification, setSelectedWeeklyPushNotification] =
    useState(null);
  const [viewModal, setViewModal] = useState(false);
  const [editModal, setEditModal] = useState(false);

  const [filters, setFilters] = useState([]);
  const [sorting, setSorting] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [pageSize, setPageSize] = useState(25);

  const dispatch = useDispatch();

  const refresh = useCallback(() => {
    dispatch(weeklyPushNotificationsActions.fetchWeeklyPushNotifications());
  });

  useEffect(() => {
    weeklyPushNotifications.length === 0 && refresh();
  }, []);

  const openViewModal = (weeklyPushNotification) => {
    setSelectedWeeklyPushNotification(weeklyPushNotification);
    setViewModal(true);
  };

  const openEditModal = (weeklyPushNotification = null) => {
    setSelectedWeeklyPushNotification(weeklyPushNotification);
    setEditModal(true);
  };

  const columns = useMemo(
    () => createTableColumns(openViewModal, openEditModal),
    [],
  );
  const [hiddenColumns, setHiddenColumns] = useState(
    columns.filter(({ hidden }) => !!hidden).map(({ name }) => name),
  );
  const handleToggleColumn = (name) => {
    setHiddenColumns(addOrRemove(hiddenColumns, name));
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs
            title="Weekly Push Notifications"
            breadcrumbItem="List"
            onRefresh={() => refresh()}
            loading={loading}
          />
          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  <Row className="align-items-center justify-content-end mb-2">
                    <Spinner
                      color="secondary"
                      animation="border"
                      hidden={!loading}
                    />
                    <CreateButton
                      label="Create new Weekly Push Notification"
                      disabled={loading}
                      onPress={openEditModal}
                    />
                    <ToggleColumnButton
                      columns={columns}
                      hiddenColumns={hiddenColumns}
                      onToggleColumn={handleToggleColumn}
                    />
                    <ExportButtonPlacement />
                  </Row>
                  <DataTableNext
                    loading={loading}
                    rows={weeklyPushNotifications}
                    columns={columns}
                    filters={filters}
                    onFiltersChange={setFilters}
                    sorting={sorting}
                    onSortingChange={setSorting}
                    currentPage={currentPage}
                    onCurrentPageChange={setCurrentPage}
                    hiddenColumns={hiddenColumns}
                    onHiddenColumnsChange={setHiddenColumns}
                    pageSize={pageSize}
                    onPageSizeChange={setPageSize}
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Modal
            size="lg"
            title="Weekly Push Notification"
            isOpen={viewModal}
            toggle={() => setViewModal(!viewModal)}
            showClose
            scrollable={false}>
            <ShowSingleElement
              element={selectedWeeklyPushNotification}
              collection="weeklyPushNotifications"
              icon="bx bx-bell"
            />
          </Modal>
          <Modal
            size="xl"
            title="Weekly Push Notification"
            isOpen={editModal}
            toggle={() => setEditModal(!editModal)}
            scrollable={false}>
            <FormWeeklyPushNotification
              closeModal={() => setEditModal(false)}
              create={!selectedWeeklyPushNotification}
              loading={loading}
              weeklyPushNotification={selectedWeeklyPushNotification}
            />
          </Modal>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default WeeklyPushNotifications;
